import React, { Fragment, useEffect, useState, memo, useMemo } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
// import { useHistory } from "react-router";
import { useNavigate,useLocation } from "react-router-dom";


import Select from "react-select";
import { formatoDinero } from "../constant/funcionesGenerales";

import tools from "../js/tools";

const TablaPro = (props) => {

    /* ============== PROPIEDADES ============== */
    const opcionesCantidadResultados = props.resultsOptions || [
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "30", label: "30" },
        { value: "40", label: "40" },
    ];

    const propRow = props.row? props.row: {}

/* 	const clasesTipos = {
        "0": "pendiente",
        "1": "transferencia",
        "2": "paypal",
        "3": "link",
        "4": "terminal",
        "5": "pendiente",
        "6": "terminal",
    }

    const clasesEstatus = {
        "danger": "cancelado",
        "1": "pendiente",
        "2": "pagado",
        "3": "revisar",
        "4": "pendiente",
        "5": "cortesia",
    }
 */
    // const history = useHistory();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(props.loading || true);

    const [headers, setHeaders] = useState(props.headers);// props.headers;

    const [rows, setRows] = useState(props.rows || []);

    const [path, setPath] = useState(props.path);
    
    const [method, setMethod] = useState(props.method || 'POST');
    
    // const [body, setBody] = useState(props.body);
    const body = props.body;

    const [totalField] = useState(props.totalField || 'CANTIDAD_RESULTADOS')

    // Paginador
    const [dataPagination, setDataPagination] = useState(props.dataPagination || {
        page: 1,
        pages: [],
        lastPage: 1,
        rowsPerPage: props.rowsPerPage? props.rowsPerPage: 10
    })

    // query params
    const search = useLocation().search;
    const search_params = new URLSearchParams(search);
    const ruta = useLocation().pathname;

    /* ============== USEEFFECT ============== */

    const memoizedBody = useMemo(() => body, [JSON.stringify(body)]);

    useEffect(() => {
        let pag = getParamsJson(window.location.href);

        let s_pagina = pag.pagina ? pag.pagina : search_params.get('page'),
            s_filas = search_params.get('rowsPerPage');

        cargarRegistros(s_pagina || 1, s_filas || dataPagination.rowsPerPage, memoizedBody.tipoFiltro);
    }, [memoizedBody, props.refresh])

    /* ============== FUNCIONES ============== */

    const selectCantidadResultados = (value) => {
        setDataPagination((s) => ({...s, rowsPerPage: value.value}));
    }

    const construirElementos = () => {	
        return rows.map((fila, i) => // e => elemento, i => index
            <tr key={`key_fila_tabla${i}`} style={{cursor: 'pointer'}}>
            {
                headers.map((h, j) => {
                    if(!h.tipo || h.tipo === 'individual')
                        return <td key={`key_fila_tabla_td${i}${j}`}
                        onClick={(e) => {
                            if(propRow.onClick)
                                if(!propRow.ignoreColumns.includes(h.texto))
                                    propRow.onClick(e, fila)
                        }}
                        >
                            {
                                h.formatear ? // si se envía este parámetro que es una función, se manda la fila como parámetro al llamarla
                                    h.formatear(fila)
                                :
                                h.formato === 'dinero' ?
                                    `$${formatoDinero(fila[h.texto])}`
                                    :
                                    fila[h.texto]
                            }
                        </td>

                    if(!h.tipo || h.tipo === 'normal')
                        return <td key={`key_fila_tabla_td${i}${j}`} 
                        onClick={(e) => {
                            if(propRow.onClick)
                                if(!propRow.ignoreColumns.includes(h.texto))
                                    propRow.onClick(e, fila)
                        }}
                        >
                            <div>
                                <strong>{fila[h.titulo]}</strong>
                                <br />
                                <small>{fila[h.texto]}</small>
                            </div>
                        </td>

                    if(h.tipo === 'categoria')
                        return <td key={`key_fila_tabla_td${i}${j}`}
                        onClick={(e) => {
                            if(propRow.onClick)
                                if(!propRow.ignoreColumns.includes(h.texto))
                                    propRow.onClick(e, fila)
                        }}
                        >
                            <div className={`alert alert-light p-2 m-0 rounded ${h.clases[fila[h.categoria]]}`} role="alert">
                                {fila[h.texto]}
                            </div>
                        </td>

                    if(!h.tipo || h.tipo === 'html')
                        return <td key={`key_fila_tabla_td${i}${j}`} style={h.style? h.style:{}}
                        onClick={(e) => {
                            if(propRow.onClick)
                                if(!propRow.ignoreColumns.includes(h.texto))
                                    propRow.onClick(e, fila)
                        }}
                        >
                            {h.html? h.html(fila): ''}
                        </td>

                    if(h.tipo === 'acciones')
                        return <td key={`key_fila_tabla_td${i}${j}`} className="detalle-col text-left"
                        onClick={(e) => {
                            if(propRow.onClick)
                                if(!propRow.ignoreColumns.includes(h.texto))
                                    propRow.onClick(e, fila)
                        }}
                        >
                        {
                            h.acciones.map((a, k) => {
                                let objeto;
                                if(a.params && Array.isArray(a.params) && a.params.length){
                                    objeto = {};
                                    a.params.forEach(param => {
                                        objeto[param] = fila[param];
                                    });
                                }

                                return <button key={`key_fila_tabla_btn${i}${j}${k}`} type="button" className="btn btn-detalle rounded-pill m-1" onClick={a.onClick ? () => {a['onClick'](objeto)} : null}>
                                    {a['texto']}
                                </button>
                            })
                        }
                        </td>
                })
            }
            </tr>
        )
    }

    const construirElementosCargando = () => {
        let arreglo = [], i;
        for(i = 0; i < dataPagination.rowsPerPage; i++){
            arreglo.push(
            <tr key={`key_fila_cargando${i}`}>
            {
                headers.map((h, j) => {
                    if(h.tipo === 'categoria')
                        return <td key={`key_fila_td_cargando${i}${j}`}>
                            <div>
                                <div className="skeleton skeleton-text skeleton-footer"></div>
                                <div className="skeleton skeleton-text skeleton-text__body"></div>
                            </div>
                        </td>

                    else
                        return <td key={`key_fila_td_cargando${i}${j}`} className="detalle-col">
                            <div className="skeleton skeleton-text skeleton-badge"></div>
                        </td>
                })
            }
            </tr>
            )
        }
        return arreglo;
    }

    const getParamsJson = (url, esUrl) => {
        var arr = url.split('?')? url.split('?'): []
        url = arr[0]
        var strParams = arr[1]
        var arrParams = strParams? strParams.split('&'): []
        var _json = {}
        if(esUrl){
            _json['url'] = url
        }
        arrParams.map((v) => {
            var arrItem = v.split('=')
            _json[arrItem[0]] = arrItem[1]
        })
        return _json
    }
    

    const cargarRegistros = (pagina, n_filas, tipoFiltro = '') => {
        setLoading(true);
        pagina = body.b?(body.b.length && tipoFiltro == 'paginador'? pagina: 1): body.tipoFiltro == 'buscador'? 1: pagina
        fetch(path, {
            method,
            body: method === 'GET' ? null : JSON.stringify(({...body, pagina, cantidad_resultados: n_filas})),
            headers: {'Content-Type': 'application/json'}
        }).then(res => res.json())
        .then(res =>  {
            body.tipoFiltro = ''
            if(res.status === 'OK'){
                if(res.result[0] && res.result[0][totalField]){
                    window.history.pushState({}, 'url', '/mesaregistro?pagina='+pagina)

                    let paginacion = infoPaginacion(pagina, res.result[0][totalField], n_filas);
                    setDataPagination((s) => {
                        if (
                            s.page !== pagina ||
                            s.pages !== paginacion.paginas ||
                            s.lastPage !== paginacion.total_paginas ||
                            s.rowsPerPage !== n_filas
                        ) {
                            return {
                                ...s,
                                page: pagina,
                                pages: paginacion.paginas,
                                lastPage: paginacion.total_paginas,
                                rowsPerPage: n_filas,
                            };
                        }
                        return s; // No actualiza el estado si no hay cambios
                    });
                    setRows(res.result);
                    setLoading(false);
                } else {
                    setDataPagination((s) => ({...s, page: 1, pages: [], lastPage: 1, rowsPerPage: n_filas}));
                    setRows([]);
                    setLoading(false);
                }
            }else{
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })

    }

    return (
    <Fragment>
        <div className="card mt-2">
            {props.paginadorTop?
            <div className="row">
                <div className="col-12 selectnum d-flex align-items-center justify-content-end flex-wrap">
                    <div className="pagin">
                        <Paginador 
                            pagina={dataPagination.page}
                            paginas={dataPagination.pages}
                            ultima_pagina={dataPagination.lastPage}
                            filasPorPagina={dataPagination.rowsPerPage}
                            cargarDatos={(pagina, n_filas, tipoFiltro) => {cargarRegistros(pagina, n_filas, tipoFiltro)}}
                            rows={rows}
                        />
                    </div>
                </div>
            </div>: ''}
            <div className="table-responsive prueba">
                <table className="table table-sticky">
                    <thead>
                        <tr>
                    {
                        headers.map((h, i) => {
                            return <th key={`key_header	_tabla${i}`} scope="col">
                                <div className="tab-header">
                                    <span className="mb-32">{h.nombre}</span>
                                </div>
                            </th>
                        })
                    }
                        </tr>
                    </thead>
                    <tbody>
                        {!loading && rows && body ?
                            construirElementos()
                            :
                            construirElementosCargando()
                        }
                    </tbody>
                </table>
            </div>
        </div>

        <div className="row">
            <div className="col-12 selectnum d-flex align-items-center justify-content-end flex-wrap">
                {/* <div className="select-number d-flex align-items-center mr-3 mb-3">
                    <label className="mb-0 mr-2">Elementos por página:</label>
                    <Select
                        style={{ width: 40 }}
                        options={opcionesCantidadResultados}
                        placeholder="10"
                        onChange={selectCantidadResultados}
                        menuPlacement="auto"
                    ></Select>
                </div> */}
                <div className="pagin">
                    <Paginador 
                        pagina={dataPagination.page}
                        paginas={dataPagination.pages}
                        ultima_pagina={dataPagination.lastPage}
                        filasPorPagina={dataPagination.rowsPerPage}
                        cargarDatos={(pagina, n_filas, tipoFiltro) => {cargarRegistros(pagina, n_filas, tipoFiltro)}}
                        rows={rows}
                    />
                </div>
            </div>
        </div>
    </Fragment>
    )
}

function infoPaginacion (pag, n_resultados /* cantidad de resultados */, n_filas /* filas por página */) {
    pag = parseInt(pag)
    var cantidad = n_filas, array_paginas = []
    var i, fin, total = Math.ceil(n_resultados/cantidad), suma = true, content = ''

    if(pag - 2 < 1){
        i = 1
        fin = 5
    }else{
        i = pag - 2
        fin = pag + 2
    }

    if(fin > total){
        fin = total
    }
    if((fin - i) < 4){
        while((fin - i) < 4 && suma){
            suma = false
            if(i > 1){
                suma = true
                i--
            }
            if((fin - i) < 4 && fin < total){
                suma = true
                fin++
            }
        }
    }

    for(i; i <= fin; i++){
        array_paginas.push(i)
    }

    return {paginas: array_paginas, total_paginas: total}
}

// const Paginador = ({pagina, paginas, ultima_pagina, cargarDatos, filasPorPagina, rows}) => {
// 	return <Pagination aria-label="Page navigation" className="pagination-primary new-pagination">
        
// 		<PaginationItem onClick={() => {cargarDatos(1, filasPorPagina);}} disabled={pagina == 1 ? true: false}>
// 			<PaginationLink className="bg-blue arrow">
// 				<i className="fa fa-angle-double-left"></i>
// 			</PaginationLink>
// 		</PaginationItem>
        
// 		<PaginationItem onClick={() => {cargarDatos(pagina-1, filasPorPagina)}} disabled={pagina == 1 ? true: false}>
// 			<PaginationLink  className="bg-blue arrow">
// 				<i className="fa fa-angle-left"></i>
// 			</PaginationLink>
// 		</PaginationItem>

// 		{
// 			paginas.map((pag, i) => {
// 				return <PaginationItem key={`PaginationItem${i}`} onClick={() => {cargarDatos(pag, filasPorPagina);}} className={pag == pagina ? "active": ""}>
// 			<PaginationLink >{pag}</PaginationLink>
// 		</PaginationItem>
// 			})
// 		}

// 		<PaginationItem onClick={() => {cargarDatos(pagina + 1, filasPorPagina);}} disabled={pagina == ultima_pagina ? true: false}>
// 			<PaginationLink className="bg-blue arrow">
// 				<i className="fa fa-angle-right"></i>
// 			</PaginationLink>
// 		</PaginationItem>
        
// 		<PaginationItem onClick={() => {cargarDatos(ultima_pagina, filasPorPagina);}} disabled={pagina == ultima_pagina ? true: false}>
// 			<PaginationLink className="bg-blue arrow">
// 				<i className="fa fa-angle-double-right"></i>
// 			</PaginationLink>
// 		</PaginationItem>

// 	</Pagination>
// }

const Paginador = ({pagina, paginas, ultima_pagina, cargarDatos, filasPorPagina, rows}) => {
    return <Pagination aria-label="Page navigation" className="pagination-primary new-pagination">
        <PaginationItem 
            disabled={pagina == 1 ? true: false}
            onClick={() => {
                if(pagina-1>=1){
                    cargarDatos(1, filasPorPagina, 'paginador');
                }
            }} 
        >
            <PaginationLink className="bg-blue arrow">
                <i className="fa fa-angle-double-left"></i>
            </PaginationLink>
        </PaginationItem>
        
        <PaginationItem onClick={() => {
            if(pagina-1>1){
                cargarDatos(pagina-1, filasPorPagina, 'paginador')
            }
        }} 
            disabled={pagina == 1 ? true: false}>
            <PaginationLink  className="bg-blue arrow">
                <i className="fa fa-angle-left"></i>
            </PaginationLink>
        </PaginationItem>

        {
            paginas.map((pag, i) => {
                return <PaginationItem key={`PaginationItem${i}`} onClick={() => {cargarDatos(pag, filasPorPagina, 'paginador');}} className={pag == pagina ? "active": ""}>
            <PaginationLink >{tools.formatNumber(pag)}</PaginationLink>
        </PaginationItem>
            })
        }

        <PaginationItem 
            disabled={pagina == ultima_pagina ? true: false}
            onClick={() => {
                if(pagina<ultima_pagina){
                    cargarDatos(pagina + 1, filasPorPagina, 'paginador');
                }
            }} 
        >

        <PaginationLink className="bg-blue arrow">
                <i className="fa fa-angle-right"></i>
            </PaginationLink>
        </PaginationItem>
        
        <PaginationItem 
            disabled={pagina == ultima_pagina ? true: false}
            onClick={() => {
                if(ultima_pagina>1 && pagina < ultima_pagina){
                    cargarDatos(ultima_pagina, filasPorPagina, 'paginador');
                }
            }} 
        >
            <PaginationLink className="bg-blue arrow">
                <i className="fa fa-angle-double-right"></i>
            </PaginationLink>
        </PaginationItem>
        <PaginationItem disabled={false}>
            <PaginationLink className="bg-blue arrow text-center">
                <span style={{fontSize:11}}>{rows[0]?tools.formatNumber(rows[0].NR):tools.formatNumber(0)}</span>
            </PaginationLink>
        </PaginationItem>
    </Pagination>
}

function areEqual(prevProps, nextProps) {
  // Compare the props that affect the rendering of the table
  // Return true if the props are equal, false otherwise
  // This is just an example, you need to customize it based on your props
  if (prevProps.loading !== nextProps.loading) {
    return false;
  }
  if (prevProps.refresh !== nextProps.refresh) {
    return false;
  }
  if (prevProps.path !== nextProps.path) {
    return false;
  }
  if (prevProps.method !== nextProps.method) {
    return false;
  }
  if (JSON.stringify(prevProps.body) !== JSON.stringify(nextProps.body)) {
    return false;
  }
  if (JSON.stringify(prevProps.headers) !== JSON.stringify(nextProps.headers)) {
    return false;
  }
  if (JSON.stringify(prevProps.rows) !== JSON.stringify(nextProps.rows)) {
    return false;
  }
  if (JSON.stringify(prevProps.dataPagination) !== JSON.stringify(nextProps.dataPagination)) {
    return false;
  }
    if (prevProps.paginadorTop !== nextProps.paginadorTop) {
    return false;
  }
  return true;
}

export default memo(TablaPro, areEqual);